import HeroHeading from '../Headings/HeroHeading'
import HeroDescription from '../Headings/HeroDescription'
import GradientButton from '../Buttons/GradientButton'

export default function HeroBanner() {
    const handleListening = () => {
        window.open(
            'https://www.youtube.com/playlist?list=PLp7MsDxHLI98b1ghXxG2SwSSVXTL4mZPp',
            '_blank',
        )
    }

    return (
        <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row items-center space-y-8 md:space-y-0 md:space-x-8">
                <div className="md:w-1/2 text-center md:text-left space-y-4 px-2">
                    <div className="space-y-4">
                        <HeroHeading>
                            Unlock the Secrets of Real Estate Success with
                            <p className="olm-gradient-text">
                                Everything Direct to Seller Marketing Podcast!
                            </p>
                        </HeroHeading>
                    </div>
                    <HeroDescription>
                        <p className="text-center md:text-left">
                            Join Justin Silverio and top real estate experts to
                            learn the best strategies, tips, and tricks for
                            direct-to-seller marketing.
                        </p>
                    </HeroDescription>
                    <div className="w-full md:w-96 mx-auto md:mx-0">
                        <GradientButton onClick={handleListening}>
                            Start Listening
                        </GradientButton>
                    </div>
                </div>
                <div className="md:w-1/2 w-full">
                    <img
                        src="/assets/podcasts/hero.png"
                        alt='A smiling man in a black baseball cap and glasses is looking at the camera. He is centered in an orange video player graphic labeled "Open Letter Marketing" with a five-star rating.'
                        title="Professional man in a video thumbnail."
                        className="w-full h-auto"
                    />
                </div>
            </div>
        </div>
    )
}
